/*
 * @Description:
 * @Date: 2024-12-12 11:54:05
 */
import AuthRedirect from '../views/auth-redirect.vue';

export const route = [
  {
    path: '/auth/auth-redirect',
    component: AuthRedirect,
    meta: {
      title: '实名认证'
    }
  }
];
